module.exports = __webpack_public_path__ + "media/images/copy-204c2b71e4c7fe1490a6b1569dd4fd91.svg";